import { clientResolver } from "resolvers";

const clientsResolver = ({ canGenerateKfiRequests, data }) => {
  return data.clients.map((client) => {
    return clientResolver({ canGenerateKfiRequests, data: client });
  });
};

export default clientsResolver;
